import { render } from "./EntreFscrean.vue?vue&type=template&id=2ede3ac6&scoped=true"
import script from "./EntreFscrean.vue?vue&type=script&lang=js"
export * from "./EntreFscrean.vue?vue&type=script&lang=js"

import "./EntreFscrean.vue?vue&type=style&index=0&id=2ede3ac6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ede3ac6"]])

export default __exports__